/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

// TODO check when this happens
export const gdprRedirect = ({ query, store, router, logger }) => {
  const business = store.getters['business/business']

  if (store.state.routingConfig.config.gdpr && store.getters['identity/isManagerOrHigher']) {
    if (business.is_gdpr_first_run) {
      logger.debug(`first time user >>> privacy`)
      return router.push({
        name: 'settings.booksy-app.privacy',
        params: {
          businessId: store.getters['business/businessId'],
        },
        query,
      })
    }
  }
}
